export const randomTags = [
	86, 81, 93, 116, 100, 148, 46, 98, 61, 154, 135, 112, 77, 100,
]
